export default "__VITE_ASSET__Btyq$R8i__"